/** Dönüşüm işinin belge türü (`donusum_isi.belge_turu`) ve Documents'taki gelen türü. */
export const HIDROTEST_BELGE_TURU = "hidrotest";
export const HIDROTEST_GELEN_TURU = "ht";
/** Olay kaydında nesne tipi (nesneId = hidrotest_kaydi.id). */
export const HIDROTEST_OLAY_NESNESI = "hidrotest_kaydi";
/** Okunan hafif excel'in belge ailesi. Hiçbir sayımda geçmez (Finishing, pano ve HT-10 yalnız "Hydrotest" ailesine bakar). */
export const HIDROTEST_GIRDI_AILESI = "Hydrotest-input";
/** DOCUMENT sayfasındaki "Document type" değeri. */
export const HIDROTEST_EXCEL_ADI = "Hydrotest certificate";
/** Okuma işi kodu: kaydın kimliğinden tireler atılmış ilk 8 karakter, büyük harf ("HT-1B8E5A37"). */
export const hidrotestKodu = (kayitId) => `HT-${kayitId.replace(/-/g, "").slice(0, 8).toUpperCase()}`;
/** Okunan değerler (sabit sıra; sözleşme §2.1, sürüm 2). Her alanın tüketicisi sözleşmede yazılıdır. `etiket` hem ekran metni hem DOCUMENT'teki Field adıdır (S2). */
export const HIDROTEST_ALANLARI = [
    { alan: "hat_tipi", etiket: "Line type", kimlik: false },
    { alan: "hat_sn", etiket: "Line serial number", kimlik: true },
    { alan: "riser_no", etiket: "Riser number", kimlik: true },
    { alan: "mwp", etiket: "MWP", kimlik: false },
    { alan: "operator_tarihi", etiket: "Operator date", kimlik: false },
    { alan: "test_unitesi_sn", etiket: "Test unit serial number", kimlik: true },
    { alan: "transducer_sn", etiket: "Transducer serial number", kimlik: true },
    { alan: "test_basinci_psi", etiket: "Test pressure (psi)", kimlik: false },
    { alan: "kabul", etiket: "Accepted", kimlik: false },
    { alan: "kabul_tarihi", etiket: "Accepted date", kimlik: false },
    { alan: "grafik_tarihi", etiket: "Chart date", kimlik: false },
    { alan: "grafik_sn", etiket: "Chart serial number", kimlik: true },
    { alan: "grafik_riser", etiket: "Chart riser number", kimlik: true },
    { alan: "grafik_baslangic", etiket: "Chart start time", kimlik: false },
    { alan: "grafik_bitis", etiket: "Chart end time", kimlik: false },
];
/**
 * D-074 Faz 2 · PR 9b: sürüm 1'in (PR 7) artık okunmayan alanları: yalnız kartta gösteriliyordu ya da kuralı kapalı (grafik_olcegi: K8).
 * Eski motorun excel'inde bu satırlar yok sayılır; eski okumaların kartında değerleri görünür. Kural açılınca alan HIDROTEST_ALANLARI'na döner.
 */
export const HIDROTEST_ESKI_ALANLARI = [
    { alan: "osi_pn", etiket: "OSI part number", kimlik: false },
    { alan: "oem_pn", etiket: "OEM part number", kimlik: false },
    { alan: "duzenleyen", etiket: "Issued by", kimlik: false },
    { alan: "muhendis", etiket: "Engineer", kimlik: false },
    { alan: "muhendis_tarihi", etiket: "Engineer date", kimlik: false },
    { alan: "operator", etiket: "Operator", kimlik: false },
    { alan: "ekipman_referanslari", etiket: "Equipment references", kimlik: false },
    { alan: "test_sivisi", etiket: "Test fluid", kimlik: false },
    { alan: "tanik", etiket: "Witness", kimlik: false },
    { alan: "grafik_basinc_notu", etiket: "Chart pressure note", kimlik: false },
    { alan: "grafik_olcegi", etiket: "Chart scale", kimlik: false },
    { alan: "iz_sayisi", etiket: "Traces on the chart", kimlik: false },
];
/** Kartın değer sırası: sürüm 1'in 27 alanlık sırası (eski okumada bütün değerler bu sırayla görünür; yeni okumada eski alanların değeri yoktur). */
export const HIDROTEST_KART_SIRASI = [
    "hat_tipi", "osi_pn", "oem_pn", "hat_sn", "riser_no", "mwp", "duzenleyen", "muhendis", "muhendis_tarihi", "operator", "operator_tarihi",
    "test_unitesi_sn", "transducer_sn", "ekipman_referanslari", "test_sivisi", "test_basinci_psi", "kabul", "kabul_tarihi", "tanik", "grafik_tarihi",
    "grafik_sn", "grafik_riser", "grafik_basinc_notu", "grafik_baslangic", "grafik_bitis", "grafik_olcegi", "iz_sayisi",
];
export const hidrotestEtiketi = (alan) => [...HIDROTEST_ALANLARI, ...HIDROTEST_ESKI_ALANLARI].find((a) => a.alan === alan)?.etiket ?? alan;
/** ROWS sayfasının başlığı (beklemeler). */
export const HIDROTEST_TUTMA_BASLIKLARI = ["#", "Hold", "Start time", "End time", "Start (MPa)", "End (MPa)", "Drop (MPa)", "As written", "Page", "Certainty"];
/* ====================================================================================================================
 * D-074 Faz 2 · PR 8: karşılaştırma ve uyarılar
 * ================================================================================================================== */
/** PR 8'de hidrotest okumasının ürettiği uyarı kodları (sıra = üretim sırası). Hiçbiri KAPALI_UYARI_KODLARI'nda olamaz (test). */
export const HIDROTEST_UYARI_KODLARI = [
    "KIM-01", "KIM-02", "KIM-07", "KIM-08", "KIM-03", "KIM-04", "KIM-05", "GEN-02", "HT-14", "HT-04", "HT-05", "HT-03", "HT-02", "HT-08", "HT-11", "HT-12", "HT-13",
];
/** Uyarı kalıpları (İngilizce anahtar; Türkçesi sözlükte). Saklanan uyarının `kalip`'i bunlardan biridir. */
export const HIDROTEST_UYARI_KALIPLARI = {
    "HT-02": "Recorded pressure {0} is outside {1} to {2}.",
    "HT-03": "Pressure drop {0} is over the limit {1}.",
    "HT-04": "Hold missing: {0}.",
    "HT-05": "Not accepted: no ACCEPTED signature.",
    "HT-08": { tarihli: "Test equipment {0} not in Registers or not calibrated on {1}.", tarihsiz: "Test equipment {0} not in Registers." },
    "HT-11": "MWP row shows the test pressure: {0}.",
    "HT-12": "Choke or Kill is not written. Line taken from the SN.",
    "HT-13": "Chart date {0} differs from certificate date {1}.",
    "HT-14": "Chart matches the chart of {0} ({1}): same times and readings.",
    "GEN-02": "Looks like a copy of {0}. Copy, new version or both?",
    "KIM-01": {
        a: "The document shows riser {0} ({1}); SN {2} is riser {0}'s {3} line. You are filing it to riser {4}.",
        b: "The document shows riser {0} ({1}), but its line SNs are riser {2}'s. The riser number is probably written wrong.",
        c: "Riser number differs between pages: {0} (p.{1}) and {2} (p.{3}).",
        d: "The document shows riser {0}; SN {1} is riser {2}'s. You are filing it to riser {3}.",
        e: "The document shows riser {0} ({1}). You are filing it to riser {2}.",
    },
    "KIM-02": { tek: "SN {0} is not a line of riser {1} in OASIS.", baska: "SN {0} is not a line of riser {1} in OASIS. {0} is also the {2} line of riser {3}." },
    "KIM-03": "Line role on the document is {0}; OASIS keeps {1}.",
    "KIM-04": "Two different SNs on one document: {0} and {1}.",
    "KIM-05": {
        iki: "Riser number and line SN not on the document. The owner comes only from your choice.",
        sn: "Line SN not on the document. The owner comes only from your choice.",
    },
    "KIM-07": {
        diger: "SN {0} is the other spelling in the MRB of the {1} line; the MRB says {2}.",
        yeni: "SN {0} is the new part ID of the {1} line; the MRB says {2}.",
        karar: "SN {0} is the decided SN ({1}, {2}) of the {3} line; the MRB says {4}.",
    },
    "KIM-08": "Probable misprint: {0} on the document; the {1} line is {2}.",
};
//# sourceMappingURL=hidrotest.js.map